import { useSearchParams } from 'react-router-dom'
import type { SortOrder } from 'antd/es/table/interface'

type Params<T> = {
  dataIndex: keyof T
  initialValue?: 'descend' | 'ascend'
}

export const useColumnLocalSort = <T>({
  dataIndex,
  initialValue,
}: Params<T>) => {
  const [searchParams] = useSearchParams()
  const sorterField = searchParams.get('sorterField')

  if (!sorterField) {
    return initialValue
      ? {
          defaultSortOrder: (initialValue === 'descend'
            ? 'descend'
            : 'ascend') as SortOrder,
        }
      : {}
  }

  const isDesc = sorterField.startsWith('-')
  const field = isDesc ? sorterField.slice(1) : sorterField

  if (field !== String(dataIndex)) return {}

  return {
    defaultSortOrder: (isDesc ? 'descend' : 'ascend') as SortOrder,
  }
}
